// extracted by mini-css-extract-plugin
export var avatar = "Home-module--avatar--UqGv+";
export var bounce = "Home-module--bounce--Glmxo";
export var home = "Home-module--home--fnG+j";